<template lang="pug">
  v-layout.mt-3(column)
    v-img.my-4(src="/static/img/ld-powered-lw-logo.svg" height="50" contain)
    v-icon.my-3(size=100) $vuetify.icons.verifying-info
    p.message Checking your information...
</template>

<script>
export default {
  name: 'LoadingPage',
}
</script>

<style lang="scss" scoped>
.message {
  text-align: center;
  font-size: 24px;
  color: var(--v-primary-base);
}
</style>
